const home = {
  hero_badge: "Las Vegas Premier Glass Company",
  hero_headline1: "Custom Shower Doors,",
  hero_headline2: "Glass Railings",
  hero_headline3: "& Mirrors in Las Vegas",
  hero_sub: "Precision-crafted glass installations for homes and businesses across the Las Vegas Valley. Frameless, modern, and built to last.",
  hero_stat1_num: "15+",
  hero_stat1_label: "Years Experience",
  hero_stat2_num: "2,000+",
  hero_stat2_label: "Projects Completed",
  hero_stat3_num: "100%",
  hero_stat3_label: "Satisfaction Rate",
  services_badge: "What We Do",
  services_heading: "Our Glass Services",
  services_sub: "From frameless shower doors to custom mirrors and glass railings — we handle every glass installation with precision and care.",
  why_badge: "Why Quinolux",
  why_heading1: "Precision Craftsmanship,",
  why_heading2: "Every Time",
  why_sub: "We're not just glass installers — we're craftsmen who take pride in every cut, every seal, and every finished installation. Here's what sets us apart from the competition.",
  gallery_badge: "Our Work",
  gallery_heading: "Recent Installations",
  areas_badge: "Where We Work",
  areas_heading1: "Serving the Greater",
  areas_heading2: "Las Vegas Valley",
  areas_sub: "We provide premium glass and mirror services across all major cities and communities in the Las Vegas metropolitan area.",
  reviews_badge: "Rated 5.0 on Google",
  reviews_heading: "What Our Clients Say",
  cta_badge: "Free Estimate",
  cta_heading1: "Transform Your",
  cta_heading2: "Space Today",
  cta_sub: "Get a free, no-obligation estimate for your glass project. We'll come to you, measure everything, and provide a detailed quote — usually within 24 hours.",
  cta_reply: "We reply within 2 hours",
  cta_immediate: "Call for immediate assistance",
  cta_form_heading: "Get Your Free Estimate",
  cta_form_sub: "No obligation. Fast response. Local experts.",
};

export default home;
